module.exports = __webpack_public_path__ + "img/CS48Q-中_02.1dd000c1.jpg";